import React, { useEffect } from "react";
import { Col, DatePicker, Flex, InputNumber, Row } from "antd";
import { useState } from "react";
import { useRef } from "react";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  dateObjToDispViewDate,
  disableOnWheel,
  sanitizeDataTypeClientSide,
  timeObjToDispViewTimeWithSuffix,
} from "../../../../../../utils/utils";
import styles from "./CouponCodes.module.scss";
import {
  createCouponCodeAction,
  getCouponCodeByIdAction,
  updateCouponCodeAction,
} from "../../../../../../redux/services/coupon-codes/couponCodesServices";
import dayjs from "dayjs";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";

const CouponCodeForm = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedCouponCodeId } = useSelector((state) => state.couponCodes);
  const [couponCodesDetails, setCouponCodesDetails] = useState(null);
  /* id dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const discountType = Form.useWatch("discount_type", { form, preserve: true });
  const start = Form.useWatch("start", { form, preserve: true });
  /* form dependencies */

  /* select list dependencies */
  /* select list dependencies */

  /* function definition for select list API calls */
  const selectListApiCalls = (details) => {};
  /* function definition for select list API calls */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedCouponCodeId &&
      selectedCouponCodeId !== "" &&
      selectedCouponCodeId !== null &&
      selectedCouponCodeId !== undefined
    ) {
      const dataToBeSent = {
        selectedCouponCodeId,
      };
      dispatch(
        getCouponCodeByIdAction(dataToBeSent, navigate, setLoading)
      ).then((apiRes) => {
        const couponCodes = apiRes;

        selectListApiCalls(couponCodes);
        setCouponCodesDetails(couponCodes);

        form.setFieldsValue({
          coupon_category: couponCodes?.coupon_category[0],
          coupon_code: couponCodes?.coupon_code,
          coupon_name: couponCodes?.coupon_name,
          discount_type: couponCodes?.discount_type,
          discountValue:
            couponCodes?.discount_type === "PERCENTAGE"
              ? couponCodes?.discount_percent
              : couponCodes?.discount_amount,
          use_count_all_user: couponCodes?.use_count_all_user,
          use_count_single_user: couponCodes?.use_count_single_user,
          start: dayjs(couponCodes?.start, "YYYY/MM/DD"),
          expiry: dayjs(couponCodes?.expiry, "YYYY/MM/DD"),
        });
      });
    } else {
      /* initial dependencies - Edit */
      selectListApiCalls(null);
    }
  }, []);

  /* Form submit handler */
  const onSubmit = (values) => {
    const { discountValue, start, expiry, discount_type, ...rest } = values;

    const dataToBeSent = {
      ...rest,
      discount_type,
      start: dateObjToDispViewDate(start, "yyyymmdd"),
      expiry: dateObjToDispViewDate(expiry, "yyyymmdd"),
    };
    if (discount_type === "PERCENTAGE") {
      dataToBeSent.discount_percent = discountValue;
      dataToBeSent.discount_amount = 0;
    }
    if (discount_type === "AMOUNT"){
      dataToBeSent.discount_amount = discountValue;
      dataToBeSent.discount_percent = 0;
    }
    dataToBeSent.coupon_category = values?.coupon_category;

    if (
      selectedCouponCodeId &&
      selectedCouponCodeId !== "" &&
      selectedCouponCodeId !== null &&
      selectedCouponCodeId !== undefined
    ) {
      dataToBeSent._id = selectedCouponCodeId;
      dispatch(updateCouponCodeAction(dataToBeSent, navigate, setLoading));
    } else {
      dispatch(createCouponCodeAction(dataToBeSent, navigate, setLoading));
    }
  };
  /* Form submit handler */

  /* start date and expiry date validation dependencies */
  const disabledStartDate = (currentDate) => {
    return currentDate && dayjs(currentDate).isBefore(dayjs(), "day");
  };

  const disabledEndDate = (value) => {
    if (!start) {
      return true;
    }
    const allowedEndDate = new Date(start);
    return value < allowedEndDate.setDate(allowedEndDate.getDate() + 1);
  };

  /* start date and expiry date validation dependencies */

  return (
    <div className={styles.couponCodesFormContainer}>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(baseRouteMakerForSuperAdmin(routes.COUPON_CODES))
            }
          />
          <Title level={2}>
            {selectedCouponCodeId
              ? t("Modules.CouponCodes.editCouponCode")
              : t("Modules.CouponCodes.addCouponCode")}
          </Title>
        </Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                name="coupon_category"
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.couponCategory")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.CouponCodes.pleaseSelectCouponCategory"
                    ),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={[
                    { value: "ORDER", label: "Order" },
                    { value: "SUBSCRIPTION", label: "Subscription" },
                  ]}
                  placeholder={t("Modules.CouponCodes.selectCouponCategory")}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.code")}
                    required={true}
                  />
                }
                name="coupon_code"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseEnterCode"
                    ),
                  },
                  {
                    whitespace: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseEnterCode"
                    ),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input
                  placeholder={t(
                    "Modules.DiscountCodes.DiscountCodesForm.enterCode"
                  )}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.couponName")}
                    required={true}
                  />
                }
                name="coupon_name"
                rules={[
                  {
                    required: true,
                    message: t("Modules.CouponCodes.pleaseEnterCouponName"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.CouponCodes.pleaseEnterCouponName"),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input
                  placeholder={t("Modules.CouponCodes.enterCouponName")}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="discount_type"
                label={
                  <RequiredLabel
                    text={t(
                      "Modules.DiscountCodes.DiscountCodesForm.discountType"
                    )}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseSelectDiscountType"
                    ),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={[
                    { value: "AMOUNT", label: "Amount" },
                    { value: "PERCENTAGE", label: "Percentage" },
                  ]}
                  placeholder={t(
                    "Modules.DiscountCodes.DiscountCodesForm.selectDiscountType"
                  )}
                  onChange={() => form.resetFields(["discountValue"])}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="discountValue"
                label={
                  <RequiredLabel
                    text={
                      discountType === "AMOUNT"
                        ? "Discount value"
                        : discountType === "PERCENTAGE"
                        ? "Discount %"
                        : "Discount value"
                    }
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message:
                      discountType === "AMOUNT"
                        ? t("Modules.Offer.OfferForm.pleaseEnterDiscountValue")
                        : discountType === "PERCENTAGE"
                        ? t(
                            "Modules.Offer.OfferForm.pleaseEnterDiscountPercent"
                          )
                        : t("Modules.Offer.OfferForm.pleaseEnterDiscountValue"),
                  },
                  {
                    validator: (_, value) => {
                      if (discountType === "PERCENTAGE") {
                        if (value && value > 100) {
                          return Promise.reject(
                            `${t(
                              "Modules.Offer.OfferForm.discountPercent"
                            )} ${t("CommonUtils.shouldNotBeGreaterThan100")}`
                          );
                        } else if (value && value < 1) {
                          return Promise.reject(
                            `${t(
                              "Modules.Offer.OfferForm.discountPercent"
                            )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder={
                    discountType === "AMOUNT"
                      ? t("Modules.Offer.OfferForm.enterDiscountValue")
                      : discountType === "PERCENTAGE"
                      ? t("Modules.Offer.OfferForm.enterDiscountPercent")
                      : t("Modules.Offer.OfferForm.enterDiscountValue")
                  }
                  onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                  disabled={!discountType || couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="use_count_single_user"
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.useCountSingleUser")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.CouponCodes.pleaseEnterUseCountSingleUser"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  type="number"
                  controls={false}
                  placeholder={t("Modules.CouponCodes.enterUseCountSingleUser")}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="use_count_all_user"
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.useCountAllUser")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.CouponCodes.pleaseEnterUseCountAllUser"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  type="number"
                  controls={false}
                  placeholder={t("Modules.CouponCodes.enterUseCountAllUser")}
                  disabled={couponCodesDetails?.is_used}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.CouponCodes.startDate")}
                    required={true}
                  />
                }
                name="start"
                rules={[
                  {
                    required: true,
                    message: t("Modules.CouponCodes.pleaseSelectStartDate"),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%", cursor: "pointer" }}
                  placeholder={t("Modules.CouponCodes.selectStartDate")}
                  onKeyDown={(event) => event.preventDefault()}
                  disabledDate={disabledStartDate}
                  onChange={() => form.setFieldValue("expiry", null)}
                  // disabled={couponCodesDetails?.is_used}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t(
                      "Modules.DiscountCodes.DiscountCodesForm.expiryDate"
                    )}
                    required={true}
                  />
                }
                name="expiry"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseSelectExpiryDate"
                    ),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%", cursor: "pointer" }}
                  placeholder={t(
                    "Modules.DiscountCodes.DiscountCodesForm.selectExpiryDate"
                  )}
                  onKeyDown={(event) => event.preventDefault()}
                  disabledDate={disabledEndDate}
                  // disabled={couponCodesDetails?.is_used}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              {/* {!couponCodesDetails?.is_used && ( */}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
              {/* )} */}
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default CouponCodeForm;
